/**
 * Chef Banchan ZIP Code Manager
 * Updated: May 2026
 * Pickup Station: 1351 S Beach Blvd M, La Habra, CA 90631 (Banchan 365 Office)
 */

(function() {
  // 이미 로드된 경우 중복 실행 방지
  if (window.ChefBanchan && window.ChefBanchan.ZipCodeManager) {
    console.log('⚠️ ZIP Code Manager already loaded');
    return;
  }

  console.log('🚀 Chef Banchan ZIP Code Manager initialization started');

  // 전역 Chef Banchan 네임스페이스
  window.ChefBanchan = window.ChefBanchan || {};

  // ZIP Code 관리자 초기화
  window.ChefBanchan.ZipCodeManager = (function() {
    
    // ⏰ 당일 주문 마감 시간 설정 (24시간 기준)
    const DAILY_CUTOFF_HOUR = 5; // 오전 5시
    
    // 🏪 픽업 설정 (Banchan 365 오피스로 변경 - 2026-05-13)
    const PICKUP_CONFIG = {
      location: {
        name: 'Banchan 365 Office',
        address: '1351 S Beach Blvd M',
        city: 'La Habra',
        state: 'CA',
        zipcode: '90631',
        phone: '(714) 867-3518'
      },
      days: [1, 2, 3, 4, 5], // 월, 화, 수, 목, 금 (토요일 픽업 안 함 - 2026-05-13)
      hours: {
        start: 13, // 1PM
        end: 19    // 7PM
      },
      cutoffHour: DAILY_CUTOFF_HOUR
    };

    // 🗓️ 공휴일 및 특별 휴무일 설정
    const holidaysAndClosedDays = {
      '2025': [
        '2025-01-01', // New Year's Day
        '2025-04-04', // 창립기념일
        '2025-07-04', // Independence Day
        '2025-09-01', // Labor Day
        '2025-11-27', // Thanksgiving
        '2025-11-28', // Black Friday
        '2025-11-29', // Thanksgiving Weekend  
        '2025-12-25', // Christmas
      ],
      '2026': [
        '2026-01-01', // New Year's Day
        '2026-04-04', // 창립기념일
        '2026-07-03', // Independence Day 관측일
        '2026-09-07', // Labor Day
        '2026-11-26', // Thanksgiving
        '2026-11-27', // Black Friday
        '2026-12-25', // Christmas
      ],
      'special': []
    };

    // ZIP Code 데이터베이스
    const zipCodeDatabase = {
      'LA_OC': [
        // Z1_Torrance_South Bay_Long Beach (67개)
        '90043','90044','90045','90047','90056','90059','90061','90062','90220','90221',
        '90222','90245','90247','90248','90249','90250','90254','90260','90261','90262',
        '90266','90274','90275','90277','90278','90280','90301','90302','90303','90304',
        '90305','90311','90501','90502','90503','90504','90505','90506','90701','90706',
        '90710','90716','90717','90723','90731','90732','90744','90745','90746','90747',
        '90755','90802','90803','90804','90805','90806','90807','90808','90810','90813',
        '90814','90815','90822','90831','90834','90835','90840',
        //Z2_Central LA_Koreatown (120개)
        '90001','90002','90003','90004','90005','90006','90007','90008','90010','90011',
        '90012','90013','90014','90015','90016','90017','90018','90019','90020','90021',
        '90022','90023','90024','90025','90026','90027','90028','90029','90031','90032',
        '90033','90034','90035','90036','90037','90038','90039','90040','90041','90042',
        '90046','90048','90057','90058','90063','90064','90065','90066','90067',
        '90068','90069','90071','90073','90077','90079','90089','90094','90095','90101',
        '90201','90210','90211','90212','90230','90232','90240','90241','90242','90255',
        '90270','90291','90292','90293','90401','90402','90403','90404','90405',
        '90640','90660','90670','91006','91007','91030','91101','91105','91106','91108',
        '91121','91123','91124','91125','91129','91182','91184','91188','91189','91203',
        '91204','91205','91206','91210','91731','91732','91733','91754','91770','91775',
        '91776','91780','91801','91803','91804',
        //Z3_Irvine_South OC (72개)
        '90620','90623','90630','90650','90680','90703','90712','90713','90715','90720',
        '90740','92602','92603','92604','92606','92610','92612','92614','92617','92618',
        '92620','92625','92626','92627','92630','92637','92646','92647','92648','92649',
        '92651','92653','92655','92656','92657','92660','92661','92662','92663','92677',
        '92679','92683','92688','92691','92692','92694','92697','92701','92703','92704',
        '92705','92706','92707','92708','92780','92782','92801','92802','92804','92805',
        '92806','92840','92841','92843','92844','92845','92861','92865','92866','92867',
        '92868','92869',
        //Z4_Fullerton_Buena Park_North OC (24개)
        '90601','90602','90603','90604','90605','90606','90621','90631','90637','90638',
        '91745','91748','92807','92808','92821','92823','92831','92832','92833','92835',
        '92870','92885','92886','92887',
      ],

      
      'SOCAL': [  // 487개
        '90049','90263','90264','90265','90272','90290','91001','91008','91010','91011','91016','91017',
        '91020','91024','91040','91041','91042','91103','91104','91107','91109','91110',
        '91114','91126','91185','91199','91201','91202','91207','91208','91214','91301',
        '91302','91303','91304','91305','91306','91307','91309','91311','91313','91316',
        '91319','91320','91324','91325','91326','91327','91328','91331','91334','91335',
        '91337','91341','91342','91343','91344','91345','91346','91350','91351','91352',
        '91353','91354','91355','91356','91357','91360','91361','91362','91363','91367',
        '91372','91377','91380','91381','91382','91383','91385','91386','91387','91390',
        '91393','91394','91396','91401','91402','91403','91404','91405','91406','91407',
        '91408','91409','91410','91411','91412','91413','91416','91423','91426','91436',
        '91501','91502','91504','91505','91506','91601','91602','91603','91604','91605',
        '91606','91607','91608','91609','91610','91614','91615','91616','91618','91701',
        '91702','91708','91709','91711','91722','91723','91724','91729','91730','91737',
        '91739','91740','91741','91744','91746','91750','91752','91758','91761','91762',
        '91763','91764','91765','91766','91767','91768','91773','91784','91785','91786',
        '91789','91790','91791','91792','91896','91901','91902','91905','91906','91910',
        '91911','91913','91914','91915','91916','91917','91931','91932','91934','91935',
        '91941','91942','91945','91949','91950','91962','91963','91977','91978','92003',
        '92008','92009','92010','92014','92019','92021','92024','92025','92026','92028',
        '92029','92036','92037','92040','92054','92056','92057','92058','92059','92064',
        '92065','92066','92069','92071','92078','92081','92082','92083','92084','92091',
        '92093','92101','92102','92104','92105','92106','92107','92108','92109','92110',
        '92111','92113','92114','92115','92116','92117','92119','92120','92121','92122',
        '92123','92124','92126','92127','92128','92129','92130','92131','92132','92136',
        '92139','92140','92145','92154','92161','92173','92181','92201','92203','92210',
        '92211','92220','92223','92230','92231','92233','92234','92236','92240','92241',
        '92243','92249','92251','92252','92253','92254','92256','92258','92259','92260',
        '92262','92263','92264','92268','92270','92273','92274','92275','92276','92277',
        '92278','92281','92282','92284','92285','92301','92305','92307','92308','92310',
        '92311','92312','92313','92314','92315','92320','92322','92324','92325','92327',
        '92331','92333','92334','92335','92336','92337','92339','92341','92342','92344',
        '92345','92346','92348','92350','92352','92354','92356','92357','92359','92365',
        '92368','92371','92372','92373','92374','92376','92377','92378','92382','92385',
        '92386','92391','92392','92394','92395','92397','92398','92399','92401','92402',
        '92403','92404','92405','92406','92407','92408','92410','92411','92413','92415',
        '92418','92423','92424','92427','92501','92502','92503','92504','92505','92506',
        '92507','92508','92509','92513','92514','92515','92516','92517','92518','92519',
        '92521','92522','92530','92532','92536','92539','92543','92544','92545','92548',
        '92549','92550','92561','92562','92563','92567','92570','92571','92582','92583',
        '92584','92585','92587','92589','92590','92591','92592','92593','92595','92596',
        '92624','92629','92672','92673','92675','92678','92860','92877','92878','92879',
        '92880','92881','92882','92883','93001','93002','93003','93004','93005','93006',
        '93007','93009','93010','93011','93012','93015','93016','93020','93021','93022',
        '93023','93024','93030','93031','93032','93033','93034','93035','93036','93041',
        '93044','93060','93061','93062','93063','93064','93065','93066','93094','93099',
        '93101','93102','93103','93105','93106','93107','93108','93109','93110','93111',
        '93117','93301','93304','93305','93306','93307','93309','93311','93312','93313',
        '93314','93401','93405','93407','93408','93449','93510','93532','93534','93536',
        '93543','93544','93550','93551','93552','93553','93591',
        // Las Vegas / Nevada (61개)
        '89002','89005','89011','89012','89014','89015','89030','89031','89032','89044',
        '89052','89074','89081','89084','89085','89086','89087','89101','89102','89103',
        '89104','89106','89107','89108','89109','89110','89113','89115','89117','89118',
        '89119','89120','89121','89122','89123','89124','89128','89129','89130','89131',
        '89134','89135','89138','89139','89141','89142','89143','89144','89145','89146',
        '89147','89148','89149','89156','89158','89161','89166','89169','89178','89179',
        '89183',
      ],
    };

    // 배송 정책 설정
    const deliveryPolicies = {
      'LA_OC': {
        name: 'Local Delivery LA/OC',
        nameEn: 'Local Delivery LA/OC',
        threshold: 99.99,
        minOrderAmount: 0,
        shippingCost: 9.99,
        shippingCost: 0,
        hasFreeShipping: true,
        hasPickup: true,
        days: [1, 2, 4, 5, 3, 6], // 월,화,목,금,수,토
        methods: {
          1: 'Direct delivery',
          2: 'Direct delivery',
          3: 'FedEx',
          4: 'Direct delivery',
          5: 'Direct delivery',
          6: 'FedEx'
        }
      },
      'SOCAL': {
        name: 'SoCal Regional Delivery',
        nameEn: 'SoCal Regional Delivery',
        threshold: 99.99,
        minOrderAmount: 0,
        shippingCost: 9.99,
        shippingCost: 0,
        hasFreeShipping: true,
        hasPickup: true,
        days: [2, 3, 4, 5, 6], // 화,수,목,금,토
        methods: {
          2: 'FedEx',
          3: 'FedEx',
          4: 'FedEx',
          5: 'FedEx',
          6: 'FedEx'
        }
      },
      'NATIONWIDE': {
        name: 'Nationwide Delivery',
        nameEn: 'Nationwide Delivery',
        threshold: 100.00,
        minOrderAmount: 0,
        shippingCost: 29.99,
        shippingCostOver100: 19.99,
        hasFreeShipping: false,
        hasPickup: true,
        days: [2, 3, 4, 5], // 화,수,목,금
        methods: {
          2: 'FedEx',
          3: 'FedEx',
          4: 'FedEx',
          5: 'FedEx'
        }
      }
    };

    // 테스트용 시간 오버라이드
    let testCurrentTime = null;

    // 테스트용 현재 시간 설정
    function setTestTime(year, month, day, hour = 0, minute = 0) {
      testCurrentTime = new Date(year, month - 1, day, hour, minute);
      console.log(`🧪 Test time set to: ${testCurrentTime.toString()}`);
      return testCurrentTime;
    }

    // 테스트 시간 해제
    function clearTestTime() {
      testCurrentTime = null;
      console.log('🧪 Test time cleared, using real time');
    }

    // 현재 시간 가져오기 (테스트 시간 우선)
    function getCurrentTime() {
      return testCurrentTime || new Date();
    }

    // 현재 시간이 주문 마감 시간 이후인지 확인
    function isPastCutoffTime() {
      const now = getCurrentTime();
      const currentHour = now.getHours();
      const isPast = currentHour >= DAILY_CUTOFF_HOUR;
      
      if (isPast) {
        console.log(`⏰ Past order cutoff time: Current ${currentHour}h (Cutoff: ${DAILY_CUTOFF_HOUR}h)`);
      }
      
      return isPast;
    }

    // 🏪 픽업 가능 여부 확인
    function canPickup(zipcode) {
      const zone = getDeliveryZone(zipcode);
      const policy = deliveryPolicies[zone];
      return policy.hasPickup || false;
    }

    // 🏪 픽업 가능 날짜 생성 (일반) - 모든 지역 가능
    function getAvailablePickupDates(zipcode, days = 21) {
      const today = getCurrentTime();
      const dayNames = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
      const dates = [];

      console.log(`🏪 Generating pickup dates: ${days} days, ZIP: ${zipcode}`);

      for (let i = 0; i < days; i++) {
        const date = new Date(today);
        date.setDate(today.getDate() + i);
        
        const dayOfWeek = date.getDay();
        let isAvailable = PICKUP_CONFIG.days.includes(dayOfWeek);
        let reasonUnavailable = '';

// 픽업 컷오프: 수(3)/토(6)는 전날 5am 마감, 나머지는 당일 5am 마감
if (isAvailable) {
  const isPrevDayCutoff = (dayOfWeek === 3 || dayOfWeek === 6);
  
  if (isPrevDayCutoff) {
    // 수/토: i=0이면 무조건 막힘, i=1이면 오늘 5am 지났으면 막힘
    if (i === 0 || (i === 1 && isPastCutoffTime())) {
      isAvailable = false;
      reasonUnavailable = `Pickup cutoff after ${PICKUP_CONFIG.cutoffHour}AM previous day`;
    }
  } else {
    // 월/화/목/금: 당일(i=0)에만 5am 체크
    if (i === 0 && isPastCutoffTime()) {
      isAvailable = false;
      reasonUnavailable = `Same day pickup cutoff after ${PICKUP_CONFIG.cutoffHour}AM`;
    }
  }
}

        // 공휴일 확인
        if (isAvailable && isHolidayOrClosedDay(date)) {
          isAvailable = false;
          reasonUnavailable = getHolidayName(date);
        }

        // 픽업 불가능한 요일
        if (!PICKUP_CONFIG.days.includes(dayOfWeek) && !reasonUnavailable) {
          reasonUnavailable = 'No pickup available';
        }

        dates.push({
          date: date,
          day: date.getDate(),
          dayName: dayNames[dayOfWeek],
          dayOfWeek: dayOfWeek,
          isAvailable: isAvailable,
          reasonUnavailable: reasonUnavailable,
          formatted: `${date.getMonth() + 1}/${date.getDate()}`,
          formattedKo: `${date.getMonth() + 1}월 ${date.getDate()}일`,
          fullDate: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`,
          isToday: i === 0,
          isTomorrow: i === 1,
          isHoliday: isHolidayOrClosedDay(date),
          holidayName: isHolidayOrClosedDay(date) ? getHolidayName(date) : null
        });
      }

      const availableCount = dates.filter(d => d.isAvailable).length;
      console.log(`✅ Pickup dates generated: ${availableCount} out of ${days} days available`);

      return dates;
    }

    // 🏪 픽업 정보 가져오기
    function getPickupInfo() {
      return {
        ...PICKUP_CONFIG.location,
        days: PICKUP_CONFIG.days,
        hours: {
          start: PICKUP_CONFIG.hours.start,
          end: PICKUP_CONFIG.hours.end,
          display: `${PICKUP_CONFIG.hours.start % 12 || 12}:00 PM - ${PICKUP_CONFIG.hours.end % 12 || 12}:00 PM`
        },
        cutoffHour: PICKUP_CONFIG.cutoffHour
      };
    }

    // 기존 함수들... (공휴일, ZIP Code 관리, 배송 정책 등)
    // [여기에 기존 ZIP Code Manager의 모든 함수들이 들어갑니다]

    // 공휴일이나 휴무일인지 확인
    function isHolidayOrClosedDay(date) {
      const dateString = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      const year = date.getFullYear().toString();
      
      const yearHolidays = holidaysAndClosedDays[year] || [];
      if (yearHolidays.includes(dateString)) {
        return true;
      }
      
      if (holidaysAndClosedDays.special.includes(dateString)) {
        return true;
      }
      
      return false;
    }

    // 공휴일 이름 가져오기
    function getHolidayName(date) {
      const dateString = date.toISOString().split('T')[0];
      const holidayNames = {
        '2025-01-01': 'New Year\'s Day',
        '2025-04-04': 'Company Anniversary',
        '2025-07-04': 'Independence Day',
        '2025-09-01': 'Labor Day',
        '2025-11-27': 'Thanksgiving',
        '2025-11-28': 'Black Friday',
        '2025-12-25': 'Christmas',
        '2026-01-01': 'New Year\'s Day',
        '2026-04-04': 'Company Anniversary',
        '2026-07-04': 'Independence Day',
        '2026-09-07': 'Labor Day',
        '2026-11-26': 'Thanksgiving',
        '2026-11-27': 'Black Friday',
        '2026-12-25': 'Christmas',
      };
      return holidayNames[dateString] || 'Holiday/Closed';
    }

    // ZIP Code 기반 배송 지역 판단
    function getDeliveryZone(zipcode) {
      if (!zipcode || zipcode.length !== 5) {
        return 'NATIONWIDE';
      }

      for (const [zone, zipcodes] of Object.entries(zipCodeDatabase)) {
        if (zipcodes.includes(zipcode)) {
          return zone;
        }
      }
      
      return 'NATIONWIDE';
    }

    // 현재 ZIP Code 가져오기
    function getCurrentZipCode() {
      return localStorage.getItem('chefBanchanZipcode') || '';
    }

    // ZIP Code 저장하기
    function setCurrentZipCode(zipcode) {
      if (zipcode && zipcode.length === 5 && /^\d{5}$/.test(zipcode)) {
        localStorage.setItem('chefBanchanZipcode', zipcode);
        localStorage.setItem('chefBanchanZone', getDeliveryZone(zipcode));
        
        console.log('💾 ZIP Code saved:', {
          zipcode: zipcode,
          zone: getDeliveryZone(zipcode),
          policy: getDeliveryPolicy(zipcode).name,
          canPickup: canPickup(zipcode)
        });
        
        window.dispatchEvent(new CustomEvent('chefBanchanZipCodeChanged', {
          detail: { 
            zipcode: zipcode, 
            zone: getDeliveryZone(zipcode),
            policy: getDeliveryPolicy(zipcode),
            canPickup: canPickup(zipcode)
          }
        }));
        
        return true;
      }
      return false;
    }

    // 배송 정책 가져오기
    function getDeliveryPolicy(zipcode) {
      const zone = getDeliveryZone(zipcode);
      return deliveryPolicies[zone];
    }

    // 현재 배송 정책 가져오기
    function getCurrentDeliveryPolicy() {
      const zipcode = getCurrentZipCode();
      return getDeliveryPolicy(zipcode);
    }

    // ZIP Code 유효성 검사
    function isValidZipCode(zipcode) {
      return zipcode && zipcode.length === 5 && /^\d{5}$/.test(zipcode);
    }

    // 배송비 계산
    function calculateShippingCost(cartTotal, zipcode) {
      const policy = getDeliveryPolicy(zipcode || getCurrentZipCode());
      const zone = getDeliveryZone(zipcode || getCurrentZipCode());
      
      // 🔥 Nationwide 특별 처리
      if (zone === 'NATIONWIDE') {
        if (cartTotal >= 100) {
          return policy.shippingCostOver100; // $19.99
        } else {
          return policy.shippingCost; // $29.99
        }
      }
      
      // LA/OC, SoCal
      if (cartTotal >= policy.threshold) {
        return 0; // 무료배송
      }
      
      return policy.shippingCost; // $9.99
    }





    // 주문 가능 여부 확인
    function canPlaceOrder(cartTotal, zipcode) {
      const policy = getDeliveryPolicy(zipcode || getCurrentZipCode());
      return cartTotal >= policy.minOrderAmount;
    }

    // 무료 배송 진행률 계산
    function calculateShippingProgress(cartTotal, zipcode) {
      const policy = getDeliveryPolicy(zipcode || getCurrentZipCode());
      const zone = getDeliveryZone(zipcode || getCurrentZipCode());
      const shippingCost = calculateShippingCost(cartTotal, zipcode);
      const canOrder = canPlaceOrder(cartTotal, zipcode);
      
      // 🔥 Nationwide 특별 처리
      if (zone === 'NATIONWIDE') {
        let message;
        
        if (cartTotal >= 100) {
          message = 'Order over $100 - Shipping $19.99';
        } else {
          const remaining = 100 - cartTotal;
          message = `Add $${remaining.toFixed(2)} more to reduce shipping to $19.99!`;
        }
        
        const percentage = Math.min((cartTotal / 100) * 100, 100);
        
        return {
          percentage: percentage,
          remaining: Math.max(100 - cartTotal, 0),
          achieved: cartTotal >= 100,
          threshold: 100,
          shippingCost: shippingCost,
          totalCost: cartTotal + shippingCost,
          canOrder: canOrder,
          hasFreeShipping: false,
          zone: zone,
          policy: policy,
          message: message
        };
      }
      
      // LA/OC, SoCal - 기존 로직
      const percentage = Math.min((cartTotal / policy.threshold) * 100, 100);
      const remaining = Math.max(policy.threshold - cartTotal, 0);
      
      return {
        percentage: percentage,
        remaining: remaining,
        achieved: percentage >= 100,
        threshold: policy.threshold,
        shippingCost: shippingCost,
        totalCost: cartTotal + (shippingCost || 0),
        canOrder: canOrder,
        hasFreeShipping: true,
        zone: zone,
        policy: policy
      };
    }

    // 배송 가능 날짜 생성 (일반)
    function getAvailableDeliveryDates(zipcode, days = 21) {
      const policy = getDeliveryPolicy(zipcode || getCurrentZipCode());
      const today = getCurrentTime();
      const dayNames = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
      const dates = [];
      const zone = getDeliveryZone(zipcode); // 🆕 이 줄 추가

      
      console.log(`📅 Generating delivery dates: ${days} days, ZIP: ${zipcode}, Policy: ${policy.name}`);
      
      for (let i = 0; i < days; i++) {
        const date = new Date(today);
        date.setDate(today.getDate() + i);
        
        const dayOfWeek = date.getDay();
        let isAvailable = policy.days.includes(dayOfWeek);
        let deliveryMethod = policy.methods[dayOfWeek] || ''; // ⚠️ const → let으로 변경
        let reasonUnavailable = '';
        
        // 🆕 여기부터 11월 26일 특별 처리 추가
         const dateString = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
         if (dateString === '2025-11-26' && zone === 'LA_OC') {
           deliveryMethod = 'Direct delivery';
           console.log('🎯 11/26 특별 처리: Local 직접배송으로 변경');
          }
        // 🆕 여기까지

        if (isAvailable && isPastCutoffTimeForDelivery(date, deliveryMethod, zipcode)) {
          isAvailable = false;
          if (deliveryMethod === 'Direct delivery') {
            reasonUnavailable = i === 0 ? `Same day direct delivery cutoff after ${DAILY_CUTOFF_HOUR}AM` : `Direct delivery order cutoff passed`;
          } else if (deliveryMethod === 'FedEx') {
            reasonUnavailable = i === 0 ? `Same day FedEx not available` : i === 1 ? `Next day FedEx cutoff after ${DAILY_CUTOFF_HOUR}AM` : `FedEx order cutoff passed`;
          }
        }
        
        if (isAvailable && isHolidayOrClosedDay(date)) {
          isAvailable = false;
          reasonUnavailable = getHolidayName(date);
        }
        
        if (!policy.days.includes(dayOfWeek) && !reasonUnavailable) {
          reasonUnavailable = 'No delivery';
        }
        
        dates.push({
          date: date,
          day: date.getDate(),
          dayName: dayNames[dayOfWeek],
          dayOfWeek: dayOfWeek,
          isAvailable: isAvailable,
          deliveryMethod: isAvailable ? deliveryMethod : '',
          reasonUnavailable: reasonUnavailable,
          formatted: `${date.getMonth() + 1}/${date.getDate()}`,
          formattedKo: `${date.getMonth() + 1}월 ${date.getDate()}일`,
          fullDate: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`,
          isToday: i === 0,
          isTomorrow: i === 1,
          isHoliday: isHolidayOrClosedDay(date),
          holidayName: isHolidayOrClosedDay(date) ? getHolidayName(date) : null
        });
      }
      
      const availableCount = dates.filter(d => d.isAvailable).length;
      console.log(`✅ Delivery dates generated: ${availableCount} out of ${days} days available`);
      
      return dates;
    }

    // 배송 방법별 주문 마감 시간 확인
    function isPastCutoffTimeForDelivery(deliveryDate, deliveryMethod, zipcode) {
      const now = getCurrentTime();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const delivery = new Date(deliveryDate.getFullYear(), deliveryDate.getMonth(), deliveryDate.getDate());
      const zone = getDeliveryZone(zipcode);
      
      const daysDiff = Math.ceil((delivery - today) / (1000 * 60 * 60 * 24));
      const deliveryDayOfWeek = delivery.getDay();
      
      console.log(`📅 Cutoff check: ${deliveryMethod}, Days diff: ${daysDiff}, Delivery day: ${deliveryDayOfWeek}, Zone: ${zone}`);
      
      if (!deliveryMethod) {
        return false;
      }
      
      // 목요일 배송 특별 규칙: SoCal/National은 화요일 오전 5시 마감
      if (deliveryDayOfWeek === 4 && (zone === 'SOCAL' || zone === 'NATIONWIDE')) {
        console.log(`🎯 Thursday delivery special rule for ${zone}: Tuesday 5AM cutoff`);
        
        if (daysDiff === 0 || daysDiff === 1) {
          return true;
        } else if (daysDiff === 2) {
          const todayDayOfWeek = today.getDay();
          if (todayDayOfWeek === 2) {
            const todayCutoff = new Date(today);
            todayCutoff.setHours(DAILY_CUTOFF_HOUR, 0, 0, 0);
            return now >= todayCutoff;
          } else {
            return true;
          }
        } else {
          const deliveryTuesday = new Date(delivery);
          deliveryTuesday.setDate(delivery.getDate() - 2);
          deliveryTuesday.setHours(DAILY_CUTOFF_HOUR, 0, 0, 0);
          return now >= deliveryTuesday;
        }
      }
      
      // 직접배송 vs FedEx
      if (deliveryMethod === 'Direct delivery') {
        if (daysDiff === 0) {
          const todayCutoff = new Date(today);
          todayCutoff.setHours(DAILY_CUTOFF_HOUR, 0, 0, 0);
          return now >= todayCutoff;
        } else {
          return false;
        }
      } else if (deliveryMethod === 'FedEx') {
        if (daysDiff === 0) {
          return true;
        } else if (daysDiff === 1) {
          const todayCutoff = new Date(today);
          todayCutoff.setHours(DAILY_CUTOFF_HOUR, 0, 0, 0);
          return now >= todayCutoff;
        } else {
          const cutoffDate = new Date(delivery);
          cutoffDate.setDate(delivery.getDate() - 1);
          cutoffDate.setHours(DAILY_CUTOFF_HOUR, 0, 0, 0);
          return now >= cutoffDate;
        }
      }
      
      return false;
    }

    // 모달용 배송 정보 문자열 생성
    function getDeliveryInfoString(zipcode) {
      const policy = getDeliveryPolicy(zipcode);
      const zone = getDeliveryZone(zipcode);
      
      let shippingInfo;
      if (policy.hasFreeShipping) {
        shippingInfo = `Free shipping on orders ${policy.threshold}+`;
      } else {
        shippingInfo = `$19.99 shipping on orders $100+`; 
      }
      
      let deliveryDaysInfo = policy.days.map(day => {
        const dayNames = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
        return dayNames[day];
      }).join('/');
      
      return {
        zone: zone,
        name: policy.name,
        nameEn: policy.nameEn,
        shippingInfo: shippingInfo,
        hasFreeShipping: policy.hasFreeShipping,
        threshold: policy.threshold,
        shippingCost: policy.shippingCost,
        deliveryDays: deliveryDaysInfo,
        deliveryMethods: policy.methods,
        hasPickup: policy.hasPickup
      };
    }

    // 배송일별 주문 마감 시간 문자열 생성
    function getCutoffTimeInfo(deliveryDate, zipcode) {
      const policy = getDeliveryPolicy(zipcode || getCurrentZipCode());
      const dayOfWeek = deliveryDate.getDay();
      const deliveryMethod = policy.methods[dayOfWeek];
      const zone = getDeliveryZone(zipcode);
      
      if (!deliveryMethod) {
        return null;
      }
      
      const today = new Date();
      const delivery = new Date(deliveryDate);
      const daysDiff = Math.ceil((delivery - today) / (1000 * 60 * 60 * 24));
      
      if (dayOfWeek === 4 && (zone === 'SOCAL' || zone === 'NATIONWIDE')) {
        return `Order by Tuesday ${DAILY_CUTOFF_HOUR}AM for Thursday delivery`;
      }
      
      if (deliveryMethod === 'Direct delivery') {
        if (daysDiff === 0) {
          return `Order by ${DAILY_CUTOFF_HOUR}AM today for same-day delivery`;
        } else {
          return `Order anytime for direct delivery`;
        }
      } else if (deliveryMethod === 'FedEx') {
        if (daysDiff === 1) {
          return `Order by ${DAILY_CUTOFF_HOUR}AM today for next-day FedEx delivery`;
        } else if (daysDiff > 1) {
          const cutoffDate = new Date(delivery);
          cutoffDate.setDate(delivery.getDate() - 1);
          return `Order by ${DAILY_CUTOFF_HOUR}AM on ${cutoffDate.toLocaleDateString()} for FedEx delivery`;
        }
      }
      
      return null;
    }

    // 공개 API
    return {
      // 핵심 함수들
      getDeliveryZone: getDeliveryZone,
      getDeliveryPolicy: getDeliveryPolicy,
      getCurrentDeliveryPolicy: getCurrentDeliveryPolicy,
      
      // ZIP Code 관리
      getCurrentZipCode: getCurrentZipCode,
      setCurrentZipCode: setCurrentZipCode,
      isValidZipCode: isValidZipCode,
      
      // 배송 관련 계산
      calculateShippingCost: calculateShippingCost,
      calculateShippingProgress: calculateShippingProgress,
      canPlaceOrder: canPlaceOrder,
      getAvailableDeliveryDates: getAvailableDeliveryDates,
      
      // 🏪 픽업 관련 함수들
      canPickup: canPickup,
      getPickupInfo: getPickupInfo,
      getAvailablePickupDates: getAvailablePickupDates,
      
      // UI 헬퍼 함수들
      getDeliveryInfoString: getDeliveryInfoString,
      getCutoffTimeInfo: getCutoffTimeInfo,
      
      // 시간/공휴일 관련 함수들
      isPastCutoffTime: isPastCutoffTime,
      isPastCutoffTimeForDelivery: isPastCutoffTimeForDelivery,
      isHolidayOrClosedDay: isHolidayOrClosedDay,
      getHolidayName: getHolidayName,
      
      // 테스트 함수들
      setTestTime: setTestTime,
      clearTestTime: clearTestTime,
      getCurrentTime: getCurrentTime,
      
      // 데이터 접근
      deliveryPolicies: deliveryPolicies,
      zipCodeDatabase: zipCodeDatabase,
      holidaysAndClosedDays: holidaysAndClosedDays,
      DAILY_CUTOFF_HOUR: DAILY_CUTOFF_HOUR,
      PICKUP_CONFIG: PICKUP_CONFIG
    };
  })();

  // 개발자 도구용 전역 접근
  window.ZipManager = window.ChefBanchan.ZipCodeManager;

  // 테스트 함수들을 전역으로 노출
  window.testTime = {
    set: window.ChefBanchan.ZipCodeManager.setTestTime,
    clear: window.ChefBanchan.ZipCodeManager.clearTestTime,
    
    testDelivery: function(zipcode = '90210') {
      const dates = window.ChefBanchan.ZipCodeManager.getAvailableDeliveryDates(zipcode, 7);
      console.log('📅 Available delivery dates:');
      dates.forEach(date => {
        if (date.isAvailable) {
          console.log(`✅ ${date.dayName} ${date.formatted} - ${date.deliveryMethod}`);
        } else {
          console.log(`❌ ${date.dayName} ${date.formatted} - ${date.reasonUnavailable}`);
        }
      });
      return dates;
    },
    
    testPickup: function(zipcode = '90210') {
      console.log('🧪 Testing pickup availability...');
      const canPickup = window.ChefBanchan.ZipCodeManager.canPickup(zipcode);
      console.log(`🏪 Can pickup at ${zipcode}: ${canPickup ? 'YES' : 'NO'}`);
      
      if (canPickup) {
        const pickupInfo = window.ChefBanchan.ZipCodeManager.getPickupInfo();
        console.log('📍 Pickup location:', pickupInfo);
        
        const dates = window.ChefBanchan.ZipCodeManager.getAvailablePickupDates(zipcode, 7);
        console.log('📅 Pickup dates:');
        dates.forEach(date => {
          if (date.isAvailable) {
            console.log(`✅ ${date.dayName} ${date.formatted} - Pickup available`);
          } else {
            console.log(`❌ ${date.dayName} ${date.formatted} - ${date.reasonUnavailable}`);
          }
        });
        return { pickupInfo, dates };
      }
      
      return null;
    }
  };

  console.log('✅ Chef Banchan ZIP Code Manager 로드 완료');
  console.log('🏪 픽업 스테이션: Banchan 365 Office ▶ 1351 S Beach Blvd M, La Habra, CA 90631');
  console.log('📞 연락처: (714) 867-3518');
  console.log('⏰ 픽업 시간: Mon-Fri 1PM-7PM');
  
  // 즉시 전역 이벤트 발생 (기존 ZIP Code가 있는 경우)
  const existingZip = window.ChefBanchan.ZipCodeManager.getCurrentZipCode();
  if (existingZip) {
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('chefBanchanZipCodeChanged', {
        detail: { 
          zipcode: existingZip, 
          zone: window.ChefBanchan.ZipCodeManager.getDeliveryZone(existingZip),
          policy: window.ChefBanchan.ZipCodeManager.getDeliveryPolicy(existingZip),
          canPickup: window.ChefBanchan.ZipCodeManager.canPickup(existingZip)
        }
      }));
      console.log('🎯 Initial event fired with existing ZIP Code:', existingZip);
    }, 100);
  }
})();